@if (datahub.timesheet.isReadyToRender) {
  <div>
    <div class="flex flex-col items-center justify-center gap-5 p-1">
      <h1 class="!m-0 text-center text-2xl/5" notranslate>{{ timesheetDescription | titlecase }}</h1>
      <div class="flex w-full items-center justify-around">
        <div class="mb-6 w-36">
          <button mat-raised-button (click)="handleReturnToTimesheetSelect()">
            <mat-icon class="!m-0 rotate-180 !text-4xl/none" [inline]="true">exit_to_app</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="w-[300px] cursor-pointer select-none" (click)="picker.open()">
          <mat-label>Work Date</mat-label>
          <input
            matInput
            readonly
            tabindex="-1"
            class="cursor-pointer !text-xl/none"
            [matDatepickerFilter]="thisWeek"
            [matDatepicker]="picker"
            [formControl]="datahub.date.selectedDate"
            (dateChange)="setDate(picker)"
          />
          <mat-datepicker-toggle matSuffix mat-raised-button [for]="picker" />
          <mat-datepicker #picker touchUi disabled="false" />
        </mat-form-field>
        <div class="mb-6 flex w-36 flex-row gap-2">
          <button mat-raised-button aria-label="Delete Timesheet" (click)="handleDelete()">
            <mat-icon class="!m-0 !text-4xl/none" [inline]="true">delete</mat-icon>
          </button>
          <button mat-raised-button aria-label="About Timesheet" (click)="datahub.launchResponsiveModal('about-timesheet')">
            <mat-icon class="!m-0 !text-4xl/none" [inline]="true">info</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <mat-tab-group
      labelPosition="bottom"
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      class="select-none"
      [selectedIndex]="currentStep"
      (selectedTabChange)="handleTabChange($event)"
    >
      <mat-tab [disabled]="shouldPreventTabChange">
        <ng-template mat-tab-label><span class="text-xl/5">Employees</span> </ng-template>
        <labor class="tab-content" />
      </mat-tab>
      <mat-tab [disabled]="shouldPreventTabChange">
        <ng-template mat-tab-label><span class="text-xl/5">Equipment</span> </ng-template>
        <equipment class="tab-content" />
      </mat-tab>
      <mat-tab [disabled]="shouldPreventTabChange">
        <ng-template mat-tab-label><span class="text-xl/5">Production</span> </ng-template>
        <production class="tab-content" />
      </mat-tab>
      <mat-tab [disabled]="shouldPreventTabChange">
        <ng-template mat-tab-label><span class="text-xl/5">Review & Submit</span> </ng-template>
        <summary class="tab-content"></summary>
      </mat-tab>
    </mat-tab-group>
  </div>
} @else {
  <div class="app-content-full-height flex items-center justify-center">
    <mat-spinner />
  </div>
}
